"use strict";

window.Components.Compound.ImageHeaderSubtext = createReactClass({
  propTypes() {
    return {
      image: PropTypes.element.isRequired,
      header: PropTypes.string,
      subtext: PropTypes.string,
      url: PropTypes.string
    };
  },
  getDefaultProps() {
    return {
      header: "Hello, world!",
      subtext: "Hello, world!"
    };
  },
  render() {
    let header = null;
    let image = null;
    if (this.props.url) {
      header = /* @__PURE__ */React.createElement("a", {
        href: this.props.url,
        className: "h4 Media-heading"
      }, " ", this.props.header, " ");
      image = /* @__PURE__ */React.createElement("a", {
        href: this.props.url,
        className: "pull-left"
      }, " ", this.props.image, " ");
    } else {
      header = /* @__PURE__ */React.createElement("span", {
        className: "h4 media-heading"
      }, " ", this.props.header, " ");
      ({
        image
      } = this.props);
    }
    return /* @__PURE__ */React.createElement("div", {
      className: "Media"
    }, /* @__PURE__ */React.createElement("div", {
      className: "Media--left Media--middle"
    }, image), /* @__PURE__ */React.createElement("div", {
      className: "Media-body Media--middle u-taLeft"
    }, header, /* @__PURE__ */React.createElement("span", {
      className: "u-tcGray"
    }, " ", this.props.subtext)));
  }
});